import { useIntersectionObserverAction } from '../../util/intersection-observer';
import { HorizontalStack } from '../alignment/horizontal-stack';
import { VerticalStack, type VerticalStackProps } from '../alignment/vertical-stack';
import { LoadingSpinner } from '../loading/spinner';
import { Item, type ListItem } from './item/list-item';
import styles from './list.module.scss';

export interface ListPagination {
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  fetchNextPage: () => Promise<any>;
}

interface ListProps {
  gap?: VerticalStackProps['gap'];
  items: ListItem[];
  pagination?: ListPagination;
}

export function List({ gap = 4, items, pagination }: ListProps) {
  const { fetchNextPage, hasNextPage, isFetchingNextPage } = pagination || {};
  const [setObservedItemRef] = useIntersectionObserverAction(fetchNextPage, {
    disabled: !hasNextPage || isFetchingNextPage || !fetchNextPage,
  });

  return (
    <VerticalStack as="ul" className={styles.list} gap={gap}>
      {items.map((item, i) => (
        <Item key={item.id} {...item} ref={i === items.length - 1 ? setObservedItemRef : undefined} />
      ))}
      {isFetchingNextPage ? (
        <HorizontalStack align="center" blockAlign="center" className={styles.loader}>
          <LoadingSpinner height={16} />
        </HorizontalStack>
      ) : null}
    </VerticalStack>
  );
}
